module.exports = __webpack_public_path__ + "a2066252127b4b19618f6c8d8c45be94.svg";